// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"0590c7dc","271":"d451493d","283":"0590c7dc","322":"0334895a","651":"882a5c16","774":"0590c7dc"}[chunkId] + ".chunk.css";
};